module.exports = __webpack_public_path__ + "img/5b01746.jpg";